import Login from "../screens/nonAuth/Login";
import Register from "../screens/nonAuth/Register";
import Dashboard from "../screens/auth/Dashboard";
import Home from "../screens/users/Home";
import About from "../screens/users/About";
import Contact from "../screens/users/Contact";
import ForgotPassword from "../screens/nonAuth/ForgotPassword";
import Booking from "../screens/auth/Booking";
import Profile from "../screens/auth/Profile";
import ServiceDetailsPage from "../components/User/Service/ServiceDetailsPage";
import Portfolio from "../screens/users/Portfolio";
import Career from "../screens/users/Career";
import PrivacyPolicy from "../components/User/PrivacyPolicy/PrivacyPolicy";
import TermsConditions from "../components/User/TermsConditions/TermsConditions";
import Blog from "../screens/users/Blog";
import BlogDetails from "../components/User/Blog/BlogDetails";
import JobDetails from "../components/User/Career/JobDetails/JobDetails";
import LegalServicesHome from "../components/User/LegalServices/LegalServicesHome";
import LegalServicesDetail from "../components/User/LegalServices/LegalServicesDetail";
import SoftwareDevelopmentHome from "../components/User/Service/SoftwareDevelopmentHome";
import WhatsappApiService from "../components/User/whatsapp/WhatsappApiService";
import SmsOtpService from "../components/User/whatsapp/SmsOtpService";
import ApiServicesHome from "../components/User/whatsapp/ApiServicesHome";

export const authRoutes = [
  {
    path: "/dashboard",
    component: <Dashboard />,
  },
  {
    path: "/bookings",
    component: <Booking />,
  },
  {
    path: "/profile",
    component: <Profile />,
  },
];

export const nonAuthRoutes = [
  {
    path: "/login",
    component: <Login />,
  },
  {
    path: "/register",
    component: <Register />,
  },
  {
    path: "/forgot-password",
    component: <ForgotPassword />,
  },
];

export const userRoutes = [
  {
    path: "/",
    component: <Home />,
  },
  {
    path: "/about",
    component: <About />,
  },
  {
    path: "/career",
    component: <Career />,
  },
  {
    path: "/career/:id",
    component: <JobDetails />,
  },
  {
    path: "/blogs",
    component: <Blog />,
  },
  {
    path: "/blogs/:slug",
    component: <BlogDetails />,
  },
  {
    path: "/contact",
    component: <Contact />,
  },
  {
    path: "/services/software-development/:slug",
    component: <ServiceDetailsPage />,
  },
  {
    path: "/services/software-development",
    component: <SoftwareDevelopmentHome />,
  },
  {
    path: "/services/api",
    component: <ApiServicesHome />,
  },
  {
    path: "/services/api/whatsapp-api",
    component: <WhatsappApiService />,
  },
  {
    path: "/services/api/sms-otp",
    component: <SmsOtpService />,
  },
  {
    path: "/services/legal-services",
    component: <LegalServicesHome />,
  },
  {
    path: "/services/legal-services/:slug",
    component: <LegalServicesDetail />,
  },
  {
    path: "/portfolio",
    component: <Portfolio />,
  },
  {
    path: "/privacy-policy",
    component: <PrivacyPolicy />,
  },
  {
    path: "/terms-conditions",
    component: <TermsConditions />,
  },
];
